import $ from 'jquery'

var reportAbuse = function($element, options) {

  /* PRIVATE VARIABLES */

  var $mainContainer = $element,
      cookieName = 'abuseXhrData',
      sessionStorage;


  /* PRIVATE METHODS */

  // constructor
  function init() {
    sessionStorage = window.sessionStorage;
    bindDomEvents();
    if (SOPHIA.loggedIn()) {
      sendAbuseFromStorage();
    }
  };

  function sendAbuseFromStorage(){
    var abuseXhrData = sessionStorage.getItem(abuseCookieName());
    sessionStorage.setItem(abuseCookieName(), null);
    if(typeof(abuseXhrData) != "undefined" && abuseXhrData !== null){
      SOPHIA.sendXHR(convertQueryStringToHash(abuseXhrData));
    }
  }

  function elementID(){
    return $mainContainer.attr('href');
  }

  function abuseCookieName(){
    return elementID() + cookieName;
  }

  function convertQueryStringToHash(query) {
    var queryString = {};
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
      var pair = vars[i].split("=");
      pair[0] = decodeURIComponent(pair[0]);
      pair[1] = decodeURIComponent(pair[1]);
        // If first entry with this name
      if (typeof queryString[pair[0]] === "undefined") {
        queryString[pair[0]] = pair[1];
        // If second entry with this name
      } else if (typeof queryString[pair[0]] === "string") {
        var arr = [ queryString[pair[0]], pair[1] ];
        queryString[pair[0]] = arr;
        // If third or later entry with this name
      } else {
        queryString[pair[0]].push(pair[1]);
      }
    }
    return queryString;
  };


  function bindDomEvents() {
    $mainContainer.on("click", function(e) {
      e.preventDefault();
      requestAbuseForm();
    });
  };

  function requestAbuseForm() {
    var xhrData = {
      url: $mainContainer.attr("href"),
      type: 'get',
      dataType: 'json'
    };
    var callbacks = {
      afterSuccess: function(response) {
        if (SOPHIA.xhrHasErrors(response) === false) {
          setTimeout(function() {
            SOPHIA.overlayBox(response.html, {
              afterLoad: function() {
                bindForm();
                checkTextarea();
              },
              beforeClose: function() {
                unbindForm();
                $mainContainer.trigger('focus');
              }
            }, $mainContainer);
          });
        }
      }
    };
    SOPHIA.sendXHR(xhrData, callbacks);
  };

  function confirmReport(elem, event, area) {
    var $form = elem.parents('form'),
        $focusElement = $(this),
        options = {
          relaunchConfirm: true,
          btnTpl: {
            smallBtn: '<button data-fancybox-close class="fancybox-close-small" title="{{CLOSE}}"></button>'
          },
          clickSlide: 'close',
          keyboard : 'close'
        };

    SOPHIA.confirm("Are you sure you want to report abuse for this " + area + "?", function() {
      submitForm($form, event)
    }, $focusElement, options);
  }

  function bindForm() {
    var $newAbuseForm = $('#new_abuse form');
    $('.fancybox-is-open #report_abuse_form input[type=checkbox]:first').trigger('focus');
    $newAbuseForm.on('submit', function(e) {
      e.preventDefault();
      if (SOPHIA.loggedIn()){
        submitForm(this, e);
      } else {
        e.preventDefault();
        sessionStorage.setItem(abuseCookieName(), $.param(getXhrDataFromForm(this)));
        SOPHIA.signInPopup('Hold on to that Thought', 'Sign in or create an account and then you can report abuse', {});
      }
    });
    // always prevent default but allow for one cancel click
    $('.cancel', $newAbuseForm).on('click', function(e) {
      e.preventDefault();
    }).one('click', function() {
      SOPHIA.closeOverlayBox();
    });

    $('.report-abuse-button', $newAbuseForm).on('click', function(e) {
      e.preventDefault();
    }).on('click', function(event) {
      if (SOPHIA.loggedIn()){
        confirmReport($(this), event, options.reportArea);
      } else {
        event.preventDefault();
        sessionStorage.setItem(abuseCookieName(), $.param(getXhrDataFromForm($newAbuseForm)));
        SOPHIA.signInPopup('Hold on to that Thought', 'Sign in or create an account and then you can report abuse', {});
      }
    });
  };

  function unbindForm() {
    $('form#new_abuse').off();
    $('form#new_abuse .cancel').off();
  };

  function checkTextarea() {
    var $abuseTextarea = $('#new_abuse textarea'),
        $reportButton  = $('#new_abuse .report-abuse-button');

    $abuseTextarea.on('keyup', function() {
      if ($abuseTextarea.val().length == 0) {
        $reportButton.addClass('disabled').prop('disabled', true);
      } else {
        $reportButton.removeClass('disabled').prop('disabled', false);
      }
    });
  }

  function submitForm(el) {
    var xhrData = getXhrDataFromForm(el);
    var callbacks = {
      afterSuccess: function(response) {
        if (response.error) {
          requestAbuseForm();
          setTimeout(function() {
            $('#report_abuse_form').append($('<p>', {class: 'inline-errors'}).text(response.error));
          }, 1000);
        } else if (SOPHIA.xhrHasErrors(response) === false) {
          SOPHIA.closeOverlayBox();
        }
      }
    };
    SOPHIA.sendXHR(xhrData, callbacks);
  };

  function getXhrDataFromForm(form){
    var $form = $(form);
    var xhrData = {
      url: $form.attr("action"),
      type: $form.attr("method"),
      data: $form.serialize()
    };
    return xhrData;
  }

  // run constructor
  init();

  /* PUBLIC METHODS */

  return {
    // public methods go here
  };

};

// jQuery plugin method
$.fn.reportAbuse = function(options) {
  return this.each(function() {
    var $this = $(this);

    // Store plugin object in this element's data if it doesn't already exist
    if (!$this.data('reportAbuse')) {
      $this.data('reportAbuse', reportAbuse($this, options));
    }
  });
};
